export default "__VITE_ASSET__f972321d__"